<template>
  <div>
    <div class="header">
      <div class="logo-container">
        <h1>
          <div class="header-logo">U+</div>
          <div>개통 신청하기</div>
        </h1>
      </div>
    </div>
    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <h2 style="text-align: center;">
            고객님! 새 휴대폰을 받으셨나요?
          </h2>
          <div class="field-control">
            <br />
            반드시 새 휴대폰을 받으신 후 신청해주세요!<br />
            새 휴대폰을 받기 전에 신청 시, 개통이 자동으로 진행되어 현재
            사용하시는 휴대폰이<br />
            중지될수 있습니다.<br />
          </div>
        </div>

        <div class="section">
          <dl class="field-group">
            <dt class="field-label">
              <label for="a">이름</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub m-input-half">
              <input
                id="a"
                type="text"
                @input="onlyText"
                name="appfName"
                class="input-text input-font"
                style="margin-right:10px"
                title="수취인 성명 입력"
                placeholder="이름"
                v-model="appfName"
              />
               <button @click="goAuth" type="button" 
                 :disabled="this.isCheckedKmc" 
                 :class="{ disabled: this.isCheckedKmc }">{{this.btntext}}</button>
              </div>
            </dd>
          </dl>
          <div v-if="this.isCheckedKmc">
          <dl class="field-group">
            <dt class="field-label">
              <label for="b">휴대폰 번호</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <input
                  id="b"
                  ref="ref_phoneNo"
                  type="text"
                  class="input-text input-font"
                  :class="{ disabled: this.isCheckedKmc}"
                  style="margin-right:10px"
                  title="휴대폰 번호"
                  placeholder="본인인증버튼을 눌러주세요"
                  @input="onlyNumber"
                  name="appfPhone"
                  v-model="appfPhone"
                  maxlength="11"
                  disabled="true"
                />
              </div>
            </dd>
          </dl>
          </div>

          <dl class="field-group">
            <dt class="field-label">
              <label for="c">신청번호</label>
            </dt>
            <dd class="field-control">
              <input
                id="c"
                type="text"
                class="input-text input-font"
                title="수취인 성명 입력"
                @input="onlyNumber"
                name="onlnAppfNo"
                placeholder="SMS로 받으신 신청번호를 입력해주세요"
                v-model="onlnAppfNo"
              />
            </dd>
          </dl>
        </div>

        <div class="goJoin_btn step-bottom-area" style="text-align: center">
          <span style="width: 100%">
            <a @click="goJoin" class="btn_typ01" id="goJoinBtn"
              ><span>개통 신청하기</span></a
            >
          </span>
        </div>
      </div>
    </div>
    <div class="section-separator" />
    <div class="dealer-info">
      <div class="dealer-container">
        <div
          class="section-header"
          style="text-align: left; margin-left: 10px;"
        >
          유의사항
        </div>
        <div class="field-control">
          <ul class="notice-text-list">
            <li class="notice-text">
              ※ 개통을 신청하시면 상담원 통화 없이 바로 개통 신청됩니다.
            </li>
            <li class="notice-text">
              ※ 개통 처리시간 : 평일 오전 10시~ 오후 7시 / 토요일 오전 10시 ~
              오후 2시
            </li>
            <li class="notice-text">
              ※ 평일은 오후 6시 이후 신청 시 익일 개통처리 되며, 토요일 오후 1시
              이후 신청 시 월요일 개통처리 됩니다.
            </li>
            <li class="notice-text">
              ※ 월요일은 개통 신청 건이 많아 신청 후 개통까지 시간이 걸리는 점
              양해 부탁 드립니다.<br />
              (접수 순으로 순차 개통 진행)
            </li>
            <li class="notice-text">
              ※ 다른 사람의 명의를 사용하면 관련 법률에 따라 처벌받을 수
              있습니다. 반드시 본인정보를 입력해 주세요.
            </li>
          </ul>
        </div>
      </div>
    </div>

    <v-dialog />
  </div>
</template>

<script>
import { activationServiceRepo } from '@/repository/activationServiceRepo'
import {
  callAuthPopup,
  updateMobileActivationAfterEntr,
  saveMobileAutnInfo
} from '@/api/common'

export default {
  name: 'afterActivation',

  data() {
    return {
      //인증
      certPhone: '',
      certName: '',
      certssn1: '',
      certKey: '',
      certNum: '',
      certInf1: '',
      certInf2: '',

      onlnAppfNo: '',
      appfPhone: '',
      appfName: '',

      custTel: '',
      custName: '',

      rsltCd: '',
      rsltMsg: '',

      putCondition: {},

      isCheckedKmc: false,
      btntext: '본인 인증하기' //2021 09.28 장희정 추가 C20210909_67455_4467455 개통신청하기
    }
  },

  mounted() {
    this.validateKmc()
  },

  methods: {
    onlyNumber(e) {
      if(e.target.name === 'appfPhone') this.appfPhone = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'onlnAppfNo') this.onlnAppfNo = e.target.value.replace(/[^0-9]/gi, '')
    },
    onlyText(e) {
      if(e.target.name === 'appfName') this.appfName = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
    },
    goJoin() {
      if (this.appfName === '') {
        this.$modal.show('dialog', {
          title: '본인 인증',
          text: '이름을 입력해주세요.',
          buttons: [
            {
              title: '확인',
              class: 'primary-button'
            }
          ]
        })
        return
      }

      if (!this.isCheckedKmc) {
        this.$modal.show('dialog', {
          title: '본인 인증 실패',
          text: '먼저 본인 인증을 진행해 주시기 바랍니다.',
          buttons: [
            {
              title: '확인',
              class: 'primary-button'
            }
          ]
        })
        return
      }
      var regExpNum = /^[0-9]{10,11}$/ //휴대폰번호 검증
      if (this.appfPhone === '') {
        this.$modal.show('dialog', {
          title: '신청 실패',
          text: '휴대폰 번호를 입력하세요.',
          buttons: [
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        })
        return
      }
      if (!regExpNum.test(this.appfPhone)) {
        this.$modal.show('dialog', {
          title: '신청 실패',
          text: '잘못된 휴대폰 번호입니다.',
          buttons: [
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        })
        return
      }
      if (this.onlnAppfNo === '') {
        this.$modal.show('dialog', {
          title: '신청 실패',
          text: '신청서 번호를 입력해 주시기 바랍니다.',
          buttons: [
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        })
        return
      }

      var regExpNumOnlnAppfNo = /^[0-9]{8}$/ //신청서 번호 검증
      if (!regExpNumOnlnAppfNo.test(this.onlnAppfNo)) {
        this.$modal.show('dialog', {
          title: '신청 실패',
          text: '신청서 번호를 확인해 주시기 바랍니다.',
          buttons: [
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        })
        return
      }

      this.putCondition.onlnAppfNo = this.onlnAppfNo

      updateMobileActivationAfterEntr(this.putCondition).then(res => {
        let jsonResponse = res.data
        this.appfName = jsonResponse.appfName
        this.onlnAppfNo = jsonResponse.onlnAppfNo
        this.appfPhone = jsonResponse.appfPhone
        this.certInf1 = jsonResponse.certInf1
        this.certInf2 = jsonResponse.certInf2
        this.certKey = jsonResponse.certKey
        this.certName = jsonResponse.certName
        this.certNum = jsonResponse.certNum
        this.certPhone = jsonResponse.certPhone
        this.certssn1 = jsonResponse.certssn1
        this.custName = jsonResponse.custName
        this.custTel = jsonResponse.custTel
        this.rsltCd = jsonResponse.rsltCd
        this.rsltMsg = jsonResponse.rsltMsg

        if (this.rsltCd === 'SUCCESS') {
          //신청서가 있는 경우

          //KMC 인증정보 datacapture Table에 저장
          let mobileData = {
            onetMblAppfNo: (this.onlnAppfNo === "") ? "-" : this.onlnAppfNo,
            dealCd: '-',
            juminNo: (this.certssn1 === "") ? "-" : this.certssn1,
            custName: (this.custName === "") ? "-" : this.custName,
            smsval: '-',
            tradeid: (this.certNum === "") ? "-" : this.certNum,
            mobilid: '-',
            no: (this.certPhone === "") ? "-" : this.certPhone,
            prdtnm: 'KMC'
          }
          // 인증정보 저장
          saveMobileAutnInfo(mobileData).then(res => {})

          this.$modal.show('dialog', {
            title: '신청 완료',
            text: this.rsltMsg,
            buttons: [
              {
                title: '확인',
                class: 'primary-button',
                handler: () => {
                  window.location.reload() // 2021 09.28 장희정 추가 C20210909_67455_4467455 개통신청하기
                }
              }
            ]
          })

          return 
        } else if (this.rsltCd === 'FAIL') {
          //신청서가 없는 경우
          this.$modal.show('dialog', {
            title: '신청 실패',
            text: this.rsltMsg,
            buttons: [
              {
                title: '확인',
                class: 'primary-button',
                handler: () => {
                  window.location.reload() // 2021 09.28 장희정 추가 C20210909_67455_4467455 개통신청하기
                }
              }
            ]
          })
          return 
        } else {
          //그 외
          this.$modal.show('dialog', {
            title: '신청 실패',
            text: '오류가 발생했습니다. 관리자에게 문의바랍니다.',
            buttons: [
              {
                title: '확인',
                class: 'primary-button',
                handler: () => {
                  window.location.reload() // 2021 09.28 장희정 추가 C20210909_67455_4467455 개통신청하기
                }
              }
            ]
          })
        }
      })
    },
    validateKmc() {
      if (this.$store.state.kmcInfo.name === '') {
        //본인인증 전 or 본인인증 실패
        return
      }
      //본인인증 성공
      this.certName = this.$store.state.kmcInfo.name
      this.certPhone = this.$store.state.kmcInfo.phoneNo
      this.appfPhone = this.$store.state.kmcInfo.phoneNo
      this.certNum = this.$store.state.kmcInfo.certNum
      this.certssn1 = this.$store.state.kmcInfo.birthDay.substring(2) //19940126 -> 940126
      if (this.certName === this.appfName) {
        this.isCheckedKmc = true

        // put /ococ/activation/v1/mobileAppfs/afterEntrRqst 후개통신청여부 업데이트
        this.putCondition.appfName = this.appfName

        this.putCondition.appfPhone = this.appfPhone
        this.putCondition.certName = this.certName
        this.putCondition.certssn1 = this.certssn1
        this.btntext="인증완료";
      } else {
        this.isCheckedKmc = false
        this.$modal.show('dialog', {
          title: '이름 불일치',
          text: '신청자의 이름과 본인인증의 정보가 일치하지 않습니다.',
          buttons: [
            {
              title: '확인',
              class: 'primary-button'
            }
          ]
        })
        return
      }
    },

    goAuth() {
      if (this.appfName === '') {
        this.$modal.show('dialog', {
          title: '본인 인증',
          text: '이름을 입력해주세요.',
          buttons: [
            {
              title: '확인',
              class: 'primary-button'
            }
          ]
        })
        return
      }

      // let url = '/after-activation/auth-popup'
      callAuthPopup().then(res => {
        Object.assign(this.$store.state.kmcInfo, JSON.parse(res))
        this.validateKmc()
      })
    }
  }
}
</script>

<style scoped>
.btn03 {
  overflow: hidden;
  margin-top: 38px;
}
.btn03 li {
  display: inline-block;
  width: 100%;
}
.btn03 li:nth-child(1) {
  float: left;
}
.btn03 li:nth-child(2) {
  float: right;
}
.btn03 li a {
  display: block;
  border-radius: 3px;
  width: 100%;
  height: 55px;
  line-height: 55px;
  text-align: center;
  font-size: 16px;
}
.btn03 li a.typ01 {
  background: #fff;
  color: #5b5b5b;
  border: 1px solid #d6d6d6;
  box-sizing: border-box;
}
.btn03 li a.typ02 {
  background: #e50689;
  color: #fff;
}
.btn03 li a.typ03 {
  background: #fff;
  color: #e50689;
  border: 1px solid #e50689;
  box-sizing: border-box;
}

button {
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  background: #7b558d;
  color: #ffffff;
  border-radius: 4px;
  min-width: 50px;
  width: 15%;
  height: 48px;
  padding-left: 0px;
  padding-right: 0px;
  border: none;
  line-height: 1;
  white-space: nowrap;
}
.input-font {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  width: 100%;
}
.m-input-half button,
.m-input-half select,
.m-input-half .m-input-half-sub {
  width: 20%;
  margin-left: 0px;
}

.m-input-half .input-text,
.m-input-half .input-font {
  width: calc(80% - 12px);
}
.field-control {
  max-width: 2048px;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  text-align: center;
}

.section-header {
  width: 100%;
  padding: 0 0 18px;
  font-size: 20px;
  font-weight: 400;
  color: #000;
  text-align: center;
  vertical-align: middle;
  border-bottom: 1px solid #ddd;
  position: relative;
}
li.notice-text:before {
  content: '';
  display: block;
  line-height: 1.4;
  position: absolute;
  top: 0;
  left: 0;
}
li.notice-text {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 1.4;
  position: relative;
  padding-left: 14px;
  margin-top: 4px;
  text-align: left;
  word-break: keep-all;
}
.btn_typ01 {
  display: block;
  background: #e50689;
  border-radius: 5px;
  height: 55px;
  line-height: 55px;
  text-align: center;
  color: #fff;
  font-size: 16px;
}
.disabled {
  color: darkgray;
  background: #f1f1f1;
}
</style>
